import { Modal } from "antd";
import classNames from "classnames";
import { isEmpty, get } from "lodash";
import Button from "../Button";
import InfoBox from "../InfoBox";
import QuickActionRed from "shared/components/SVG/LMF/QuickActionRed";
import { useMediaQuery } from "react-responsive";

const CustomModal = ({
    open,
    setOpen,
    title,
    titleVariant,
    highlightedTitle,
    dangerTitle,
    subTitle,
    icon,
    children,
    footer = true,
    onSubmit,
    disabled,
    TRANSLATION,
    description,
    width = 500,
    closeText = TRANSLATION?.CLOSE,
    confirmText = TRANSLATION?.CONFIRM,
}) => {

    const isMobile = useMediaQuery({ maxWidth: 768 });

    const renderTitle = () => {
        switch (titleVariant) {
            case "highlighted":
                return (
                    <span
                        className="lmfcustom__modal--title title--highlighted"
                        dangerouslySetInnerHTML={{ __html: title }}
                    />
                );
            case "danger":
                return (
                    <span className="lmfcustom__modal--title title--danger">{title}</span>
                );
            default:
                return (
                    <span className="lmfcustom__modal--title title--default">{title}</span>
                );
        }
    };

    return (
        <Modal
            open={open}
            onCancel={() => setOpen(false)}
            width={isMobile ? "90%" : width}
            footer={null}
            centered
            className="lmfcustom__modal"
        >
            <div className="lmfcustom__modal--wrapper">
                {(icon || title || subTitle) && (
                    <div className="lmfcustom__modal--head">
                        {icon && <div className="lmfcustom__modal--icon">{icon}</div>}
                        {title && renderTitle()}
                        {subTitle && <p className="lmfcustom__modal--subtitle">{subTitle}</p>}
                    </div>
                )}

                <div className="lmfcustom__modal--body">
                    {description && <p className="lmfcustom__modal--description" dangerouslySetInnerHTML={{ __html: description }} />}
                    {children && <div className="lmfcustom__modal--content">{children}</div>}
                </div>

                {footer && (
                    <div className="lmfcustom__modal--actions">
                        <Button
                            onClick={() => setOpen(false)}
                            className="w-40"
                            type="white"
                            size="large"
                        >
                            <span>{closeText}</span>
                        </Button>
                        {onSubmit && (
                            <Button
                                disabled={disabled}
                                onClick={onSubmit}
                                type={disabled ? "white" : "primary"}
                                size="large"
                                className="w-full"
                            >
                                <span>{confirmText}</span>
                            </Button>
                        )}
                    </div>
                )}
            </div>
        </Modal>
    );
};

export default CustomModal;
